import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router} from 'react-router-dom'
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

//setting up redux
import { createStore, applyMiddleware } from 'redux';
import { Provider } from "react-redux"
import rootReducer from './reducer/rootReducer';
import thunk from 'redux-thunk';


//setting up store
const store = createStore(rootReducer, applyMiddleware(thunk)) //setting up just a base state for now

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();